import { axiosClient } from "../api/axiosClient";
import { ENDPOINTS } from "../api/endpopints";
import {
  checkPromoByCode,
  fetchBizdevJob,
  fetchCitybyMaster,
  fetchClassByProgram,
  fetchMemberByEmail,
  fetchPriceByType as requestPriceByType,
  fetchProgramByType,
  fetchRecap,
  fetchRegister,
  fetchTeacher,
  fetchTypeByCity,
  setMemberStatusByEmail
} from "../api/englishCourseApi";

export const getCity = async () => {
  try {
    const response = await fetchCitybyMaster();
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengambil kota kursus:", error);
    throw error;
  }
};

export const getTeacher = async () => {
  try {
    const response = await fetchTeacher();
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengambil data guru:", error);
    throw error;
  }
};

export const getRecap = async () => {
  try {
    const response = await fetchRecap();
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengambil data recap:", error);
    throw error;
  }
};

export const getBizdev = async () => {
  try {
    const response = await fetchBizdevJob();
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengambil data Bizdev:", error);
    throw error;
  }
};

export const getType = async (_selectedCityId) => {
  try {
    const response = await fetchTypeByCity(_selectedCityId);
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengambil tipe pembelajaran:", error);
    throw error;
  }
};

export const getProgram = async (_selectedCityId, _selectedLearningType) => {
  try {
    const response = await fetchProgramByType(_selectedCityId, _selectedLearningType);
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengambil program:", error);
    throw error;
  }
};

export const getClass = async (
  _selectedCityId,
  _selectedLearningType,
  _selectedProgram
) => {
  try {
    const response = await fetchClassByProgram(
      _selectedCityId,
      _selectedLearningType,
      _selectedProgram
    );
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengambil jumlah pertemuan:", error);
    throw error;
  }
};

export const getPrice = async (data) => {
  try {
    const response = await requestPriceByType(data);
    return response.data.data;
  } catch (error) {
    console.error("Gagal mengambil harga:", error);
    throw error;
  }
};

/**
 * Shared pricing call (used by CheckoutForm and CourseInfo).
 * Builds FormData and delegates to {@link getPrice} / API.
 */
export const fetchPriceByType = async ({
  id_program,
  id_type,
  id_area,
  schedule,
  non_member = "N",
}) => {
  const formData = new FormData();
  formData.append("id_program", String(id_program ?? ""));
  formData.append("id_type", String(id_type ?? ""));
  formData.append("id_area", String(id_area ?? ""));
  formData.append("schedule", String(schedule ?? ""));
  formData.append("non_member", non_member);
  return getPrice(formData);
};

export const getMember = async (_inputEmail) => {
  try {
    const response = await fetchMemberByEmail(_inputEmail);
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengambil data member:", error);
    throw error;
  }
};

export const getElicos = async () => {
  const response = await axiosClient.get(ENDPOINTS.eventElicos);
  return response.data.data;
};

export const checkMember = async (
  _selectedProgram,
  _selectedClassMeet,
  _selectedCityId,
  _selectedLearningType,
  result,
  _statusPayment,
  _student
) => {
  try {
    const response = await setMemberStatusByEmail(
      _selectedProgram,
      _selectedClassMeet,
      _selectedCityId,
      _selectedLearningType,
      result,
      _statusPayment,
      _student
    );
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal set status member:", error);
    throw error;
  }
};

export const checkPromo = async (
  _selectedProgram,
  _selectedClassMeet,
  _selectedCityId,
  _selectedLearningType,
  _inputPromoCode
) => {
  try {
    const response = await checkPromoByCode(
      _selectedProgram,
      _selectedClassMeet,
      _selectedCityId,
      _selectedLearningType,
      _inputPromoCode
    );
    return response.data.data; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal set status promo:", error);
    throw error;
  }
};

export const postRegister = async (
  _typeCourse,
  _inputFirstName,
  _inputLastName,
  _inputPhone,
  _inputEmail,
  _inputAddress,
  _selectedProgram,
  _selectedLearningType,
  _selectedClassMeet,
  _selectedMeetWeekly,
  _midtransPrice,
  _selectedCityId,
  _selectedBizdev,
  _inputPromoCode,
  _duration,
  formattedSchedules,
  _reasons,
  _other,
  _ielts,
  _inputReferalCode,
  _teacherList,
  exam_depart
) => {
  try {
    const response = await fetchRegister(
      _typeCourse,
      _inputFirstName,
      _inputLastName,
      _inputPhone,
      _inputEmail,
      _inputAddress,
      _selectedProgram,
      _selectedLearningType,
      _selectedClassMeet,
      _selectedMeetWeekly,
      _midtransPrice,
      _selectedCityId,
      _selectedBizdev,
      _inputPromoCode,
      _duration,
      formattedSchedules,
      _reasons,
      _other,
      _ielts,
      _inputReferalCode,
      _teacherList,
      exam_depart
    );
    return response; // sesuai struktur respons dari backend
  } catch (error) {
    console.error("Gagal mengirim data registrasi:", error);
    throw error;
  }
};